import { TourConfig } from "@/types/tour"
import { standardOffset } from "./utils/floatingUIConfigs"

/**
 * Tour configuration for the Variable Explorer page
 */
export const variableExplorerTour: TourConfig = {
   id: "variable_explorer_tour",
   humanReadableName: "Variable Explorer Tour",
   skippable: true,
   options: {
      useModalOverlay: true,
      defaultStepOptions: {
         classes: "q-card q-dark-transition shepherd-theme-quasar",
         arrow: true,
         scrollTo: { behavior: "smooth", block: "center" },
      },
   },
   steps: [
      {
         id: "welcome",
         title: "Welcome to the Variable Explorer",
         text: "The Variable Explorer helps you see how different versions of one or two variables are performing. Use it to spot which changes are driving results and better understand ezbot's impact. This tour will show you how it works.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
      },
      {
         id: "variable-selector",
         title: "Variable Selection",
         text: "Use this dropdown to select a variable you want to analyze. You can explore how different variations of this variable perform across your site.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "#variable-selector-dropdown-1",
            on: "right",
         },
         floatingUIOptions: standardOffset,
      },
      // {
      //    id: "variable-selector-2",
      //    title: "Variable 2 Selection",
      //    text: "Optionally, use this dropdown to select a second variable to analyze. This will allow you to see how different variations of both variables perform across your site.",
      //    buttons: [
      //       {
      //          action: function () {
      //             // Shepherd adds this method to the button context
      //             if (this.back) return this.back()
      //             return undefined
      //          },
      //          classes: "shepherd-button-secondary q-ml-sm",
      //          text: "Back",
      //       },
      //       {
      //          action: function () {
      //             // Shepherd adds this method to the button context
      //             if (this.next) return this.next()
      //             return undefined
      //          },
      //          classes: "shepherd-button-primary q-ml-sm",
      //          text: "Next",
      //       },
      //    ],
      //    attachTo: {
      //       element: "#variable-selector-dropdown-2",
      //       on: "right",
      //    },
      //    floatingUIOptions: standardOffset,
      // },
      {
         id: "time-of-day-chart",
         title: "Performance by Time of Day",
         text: "This radar chart shows how often each variation is shown—or how well it performs—at different times of day (in UTC). Use it to spot time-based patterns in user behavior and performance.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "#time-of-day-chart",
            on: "left",
         },
         floatingUIOptions: standardOffset,
      },
      {
         id: "serving-conversion-toggle",
         title: "Serving Rate vs Conversion Rate",
         text: "Toggle the radar chart between viewing how often a variation is shown (serving rate) and how well it performs (conversion rate) at different times of day. This can reveal how ezbot favors variations and how they perform at certain times.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.next) return this.next()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Next",
            },
         ],
         attachTo: {
            element: "#serving-conversion-toggle",
            on: "bottom",
         },
         floatingUIOptions: standardOffset,
      },
      {
         id: "tour-complete",
         title: "Tour Complete",
         text: "You've completed the Variable Explorer tour! You can now dig into variable-level performance and make data-driven decisions to optimize your site.",
         buttons: [
            {
               action: function () {
                  // Shepherd adds this method to the button context
                  if (this.back) return this.back()
                  return undefined
               },
               classes: "shepherd-button-secondary q-ml-sm",
               text: "Back",
            },
            {
               action: function () {
                  if (this.complete) return this.complete()
                  return undefined
               },
               classes: "shepherd-button-primary q-ml-sm",
               text: "Complete",
            },
         ],
         floatingUIOptions: standardOffset,
      },
   ],
}
